/* SLE Product Page interactions: gallery, finish swatches → variant/SKU/price,
   click-to-copy SKU, cursor tooltips, qty stepper.
   Reads variant data from #sle-variant-data (JSON) rendered by the hero section. */
(function () {
  'use strict';

  /* ---------- cursor tooltip (shared) ---------- */
  var tip = document.getElementById('sleCursorTip');
  if (!tip) {
    tip = document.createElement('div');
    tip.id = 'sleCursorTip';
    document.body.appendChild(tip);
  }
  function moveTip(e) {
    var pad = 14, x = e.clientX + pad, y = e.clientY + pad;
    var r = tip.getBoundingClientRect();
    if (x + r.width > window.innerWidth - 8) x = e.clientX - r.width - pad;
    if (y + r.height > window.innerHeight - 8) y = e.clientY - r.height - pad;
    tip.style.left = x + 'px'; tip.style.top = y + 'px';
  }
  window.sleBindTip = function (el, getHtml) {
    el.addEventListener('mouseenter', function (e) { tip.innerHTML = getHtml(); tip.style.display = 'block'; moveTip(e); });
    el.addEventListener('mousemove', moveTip);
    el.addEventListener('mouseleave', function () { tip.style.display = 'none'; });
  };

  /* ---------- hero: variants, swatches, SKU, gallery ---------- */
  var dataEl = document.getElementById('sle-variant-data');
  var hero = document.querySelector('[data-sle-hero]');
  if (dataEl && hero) {
    var variants = JSON.parse(dataEl.textContent);
    var mainImage = hero.querySelector('[data-main-image]');
    var thumbs = hero.querySelector('[data-thumbs]');
    var swatches = hero.querySelector('[data-swatches]');
    var finishName = hero.querySelector('[data-finish-name]');
    var skuBtn = hero.querySelector('[data-sku-copy]');
    var priceEl = hero.querySelector('[data-price]');
    var idInput = hero.querySelector('[data-variant-id]');
    var atc = hero.querySelector('[data-atc]');

    /* optional second-option (e.g. arm length) selector */
    var arms = hero.querySelector('[data-arms]');
    var armName = hero.querySelector('[data-arm-name]');
    var armKey = arms ? 'option' + (parseInt(arms.dataset.armPos, 10) || 2) : null;

    function clearCurrent(scope) {
      scope.querySelectorAll('button[aria-current="true"]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
    }

    /* current selection, seeded from the server-rendered defaults */
    var state = {
      finish: swatches && swatches.querySelector('button[aria-current="true"]')
        ? swatches.querySelector('button[aria-current="true"]').dataset.finish
        : (variants[0] && variants[0].option1),
      arm: arms && arms.querySelector('button[aria-current="true"]')
        ? arms.querySelector('button[aria-current="true"]').dataset.arm
        : null
    };

    function resolveVariant() {
      var matches = variants.filter(function (v) {
        if (state.finish != null && v.option1 !== state.finish) return false;
        if (armKey && state.arm != null && v[armKey] !== state.arm) return false;
        return true;
      });
      if (!matches.length) return null;
      return matches.filter(function (v) { return v.available; })[0] || matches[0];
    }

    function applyVariant(v, fromImage) {
      if (!v) return;
      if (finishName && state.finish != null) finishName.textContent = state.finish;
      if (armName && state.arm != null) armName.textContent = state.arm;
      if (skuBtn && v.sku) skuBtn.textContent = v.sku;
      if (priceEl) priceEl.textContent = v.price;
      if (idInput) idInput.value = v.id;
      if (atc) {
        atc.disabled = !v.available;
        atc.querySelector('span').textContent = v.available ? atc.dataset.labelAdd : atc.dataset.labelSoldout;
      }
      if (fromImage && mainImage && v.image) { mainImage.src = v.image; mainImage.alt = 'Finish: ' + state.finish; }
    }

    if (thumbs && mainImage) {
      thumbs.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          mainImage.src = b.dataset.full;
          mainImage.alt = b.querySelector('img') ? b.querySelector('img').alt : '';
          clearCurrent(thumbs); if (swatches) clearCurrent(swatches);
          b.setAttribute('aria-current', 'true');
        });
      });
    }

    if (swatches) {
      swatches.querySelectorAll('button[data-finish]').forEach(function (b) {
        b.addEventListener('click', function () {
          state.finish = b.dataset.finish;
          var v = resolveVariant();
          if (!v) return;
          applyVariant(v, true);
          clearCurrent(swatches); if (thumbs) clearCurrent(thumbs);
          b.setAttribute('aria-current', 'true');
        });
      });
    }

    if (arms) {
      arms.querySelectorAll('button[data-arm]').forEach(function (b) {
        b.addEventListener('click', function () {
          state.arm = b.dataset.arm;
          var v = resolveVariant();
          if (!v) return;
          applyVariant(v, false);
          clearCurrent(arms);
          b.setAttribute('aria-current', 'true');
        });
      });
    }

    if (skuBtn) {
      var copied = false;
      window.sleBindTip(skuBtn, function () { return copied ? 'Copied ✓' : 'Click to copy'; });
      skuBtn.addEventListener('click', function () {
        var sku = skuBtn.textContent.trim();
        function done() {
          copied = true; tip.innerHTML = 'Copied ✓';
          setTimeout(function () { copied = false; if (tip.style.display === 'block') tip.innerHTML = 'Click to copy'; }, 1600);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(sku).then(done, function () { fallbackCopy(sku); done(); });
        } else { fallbackCopy(sku); done(); }
      });
    }
    function fallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text; document.body.appendChild(ta);
      ta.select(); document.execCommand('copy'); ta.remove();
    }

    hero.querySelectorAll('[data-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = hero.querySelector('[data-qty-input]');
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.qtyBtn, 10));
      });
    });
  }

  /* ---------- finishes section: sample tooltips ---------- */
  document.querySelectorAll('[data-finish-card]').forEach(function (a) {
    var img = a.dataset.sampleImg;
    window.sleBindTip(a, function () {
      return (img ? '<img src="' + img + '" alt="">' : '') + 'Click to order finish sample';
    });
  });
})();
